var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_container"},[_c('el-container',[_c('el-header',{staticStyle:{"height":"61px"},style:({backgroundImage:'url(' + require('@/assets/image/header-background.jpg') + ')',
      backgroundRepeat:'no-repeat',
      backgroundSize:'100% 100%'})},[_c('Header')],1),_c('el-container',[_c('el-aside',{staticStyle:{"overflow-x":"hidden"},attrs:{"width":_vm.aside_width}},[_c('Aside')],1),_c('el-main',[_c('TagsView')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }